module.exports = __webpack_public_path__ + "img/laptop.62dfb529.svg";